import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { AppointmentService, SubscribeService, CommonService } from '../../../services/index';
import { AppointmentModel } from '../../../model';
import { clientOutComponent } from '../../common/clientOut.component';

import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import { TestBillGenerationComponent } from '../clientWalkIn/testBillGeneration.component';

@Component({
    selector: 'appointment-tab',
    templateUrl: './appointment.component.html'
})
export class AppointmentComponent implements OnInit {

    isLoadMask: Promise<any>;
    appointmentData: AppointmentModel[];
    loadingIndicator: boolean = true;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'date',
        orderDir: 'asc'
    };
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    @ViewChild('assignToModal') assignToModalTemp: TemplateRef<any>;
    columns = [];
    toggleCol = [];
    filterData = {
        "search_data": "",
        "from_date":new Date(),
        "to_date":new Date()
    };
    scrollTimeout: any;
    suppressPaging: boolean = false;
    userType:any;
    hasAdmin: boolean = false;
    haUserList: any[] = [];
	emplistCtrl: FormControl;
    filteredEmp: Observable<any[]>;
    selectedRow:any = {};
    pageType = 'HV';

    constructor(public store: Store<fromRootStore.State>, public toasterService: ToasterService, private appointmentService: AppointmentService, public subscribeService: SubscribeService, public commonService: CommonService, private modalService: BsModalService) {

        function hasValidEmp(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidEmp: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidEmp: true };
            }
            return retVal;
        }
        this.emplistCtrl = new FormControl('', [
            Validators.required,
            hasValidEmp.bind(this)
        ]);

        
        this.filteredEmp = this.emplistCtrl.valueChanges
        .startWith(null)
        .map(name => name ? this.filterEmp(name) : this.haUserList.slice());
    }

    ngOnInit(): void {
        let that = this;
        this.loadHaUserList();

        // TO GET USER TYPE
        this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin'] && (auth['usertype'] == 'Admin' || auth['usertype'] == 'Super_Admin')) {
                this.hasAdmin = true;
            }
        });

        //page_prop -- OWN VARIABLE
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellClass: 'cell-center', cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Entry Date', prop: 'walk_in_date', width: 120, minWidth: 120, maxWidth: 120, toggle: true, page_prop: 'Appointment' },
            { name: 'Appointment Date', prop: 'hv_date_format', width: 180, minWidth: 180, maxWidth: 180, toggle: true, page_prop: 'Appointment' },
            { name: 'Client ID', prop: 'client_no', width: 120, minWidth: 120, maxWidth: 120, page_prop: 'Appointment' },
            { name: 'Name', prop: 'client_name', sortable: false, width: 140, minWidth: 140, maxWidth: 140 , page_prop: 'Appointment'},
            { name: 'Phone', prop: 'mobile', sortable: false, width: 120, minWidth: 120, maxWidth: 120, page_prop: 'Appointment'},
            { name: 'Age', prop: 'age', sortable: false, width: 80, minWidth: 80, maxWidth: 80 , page_prop: 'Appointment'},
            { name: 'City', prop: 'city', sortable: false, width: 120, minWidth: 120, maxWidth: 120 , page_prop: 'Appointment'},
            { name: 'Reference', prop: 'reference_name', sortable: false, width: 140, minWidth: 140, maxWidth: 140 , page_prop: 'Appointment'},
            { name: 'HV Team Name', prop: 'assigned_to', sortable: false, width: 140, minWidth: 140, maxWidth: 140 , page_prop: 'Appointment'},
            { name: 'HV Status', prop: 'hv_status_text', sortable: false, width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-left', page_prop: 'Appointment'},
            { name: 'Actions', prop: 'action', sortable: false,  width: 140, minWidth: 140, maxWidth: 260, cellClass: 'cell-left', cellTemplate: this.editDeleteTemplate }
        ];
        if (this['params']['tabParams'] === 'SOA Appointment') {
            this.columns[this.columns.length - 3]['name'] = 'SOA Team Name';
            this.columns[this.columns.length - 2]['name'] = 'SOA Status';
            this.pageType = 'SOA';
        }
        this.toggleCol = Object.assign({}, this.columns);
        this.pageCallback({ offset: 0 });

        this.subscribeService.publishReloadAppointmentGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });
    }
    displayHaEmp(empid: number) {
		if (empid && this.haUserList.length > 0) {
            let fitem = _.find(this.haUserList, { 'empid': empid });
            return fitem['empname'];
        }
        return '';
    }

    filterEmp(name: string) {
        name = _.escapeRegExp(name);
        return this.haUserList.filter(ha => (new RegExp(name, 'gi').test(ha.empid) || new RegExp(name, 'gi').test(ha.empname)));
    }

	loadHaUserList() {
        let that = this,
            data = {
                name: '',
                type: 'challan'
            };
        this.commonService
            .getEmployeeName(data)
            .then(function (res: any) {
                that.haUserList = res['data'];
            });
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        //this.subscribeService.publishReloadAppointmentGrid().unsubscribe();
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterTextBox').focus();
        }, 100);

    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getAppointmentList();
    }

    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: any) {
        const offset = pageInfo.offset !== undefined ? pageInfo.offset : (pageInfo.page ? pageInfo.page - 1 : 0);
        this.page.offset = offset;
        this.getAppointmentList();
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100);
    }
    clearFilter(): void {
        this.filterData = {
            "search_data": "",
            "from_date": new Date(),
            "to_date": new Date()
        };
        this.applyFilter();
    }
    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getAppointmentList();
    }
    getAppointmentList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            search_data: this.filterData['search_data'],
            from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
            from_page: this['params']['tabParams']
        };
        let that = this;
        //this.store.dispatch(new commonActions.LoadAllSku(params));
        this.isLoadMask = this.appointmentService
            .getAppointmentList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.appointmentData = res.data;
            });
    }
    bsModalRef: BsModalRef;
    public clientOutStaus(row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(clientOutComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg compWidth-75'
        });
        row['page_from'] = this['params']['tabParams'];
        row['tabParams'] = this['params']['tabParams'];
        row['pageType'] = this.pageType;
        row['from_type'] = this.pageType;
        this.bsModalRef.content.clientStatus = Object.assign({}, row);
        this.bsModalRef.content.clientOutLoadEvent.subscribe(($e) => {
            that.getAppointmentList();
        });
    }
    public showAssignTo(row: any): void {
        this.selectedRow = Object.assign({}, row);
        this.selectedRow['from_page'] = this['params']['tabParams'];
        // this.selectedRow.assign_empid = '';
        this.bsModalRef = this.modalService.show(this.assignToModalTemp, {
            keyboard: false,
            ignoreBackdropClick: true
        });
    }

    onBillGeneration(row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(TestBillGenerationComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        //row['page_from'] = 'ClientWalkIn';
        this.bsModalRef.content.clientWalkInDet = Object.assign({}, row);
        this.bsModalRef.content.walkInTestBillEvent.subscribe(($e) => {
            that.getAppointmentList();
        });
    }

    changeAppointmentUser(): void {
        let that = this;
        this.isLoadMask = this.appointmentService
            .changeAppointmentUser(that.selectedRow)
            .then(function(res: any) {
                if (res && res.success) {
                    swal(
                        'SUCCESS',
                        res.message,
                        'success'
                    );
                    that.bsModalRef.hide();
                    that.getAppointmentList();
                } else {
                    that.toasterService.pop({
                        type: 'warning',
                        title: 'WARNING',
                        body: (res && res.message) ? res.message : 'Oops, Something Went Wrong'
                    });
                }
            });
    }
    
    onAppointmentPickClick(mode: string, row: any): void {
        let that = this,
            ha_data = JSON.parse(JSON.stringify(row));
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);
        ha_data['mode'] = mode;
        // ha_data['walkin_id'] = '';
        row['description'] = '';
        ha_data['pageType'] = this.pageType;
        ha_data['page_from'] = this['params']['tabParams'];
        if (ha_data.hv_status_text === this.pageType + '-SRF-Booking') {
            ha_data['ser_id'] = '';
            that.subscribeService.subScribeTabID('Transaction', 'AddServiceWalkInComponent', ha_data, 'Service Walk-in');
        } else  if (ha_data.hv_status_text === this.pageType + '-SRF-Delivery') {
            that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', ha_data, this.pageType);
        } else {
            that.subscribeService.subScribeTabID('Transaction', 'AddClientWalkInComponent', ha_data, this['params']['tabParams']);
        }
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/appointment/appointment.component.ts